<div class="card-heading">
  <h5 class="card-title" name="title">
    <span class="background-light">{{ heading() }}</span>
  </h5>
  <div class="right">
    <div class="actions-wrapper">
      @if (description) {
        <i
          class="icon help far fa-question-circle"
          name="description"
          placement="bottom"
          container="body"
          tooltipClass="card-tooltip"
          [ngbTooltip]="description"
        ></i>
      }
      <ng-content select="[actions]" />

      @if (showFavorites()) {
        <app-favorite-list
          [chart]="chart()"
          [favorites]="favorites()"
          [dashboards]="dashboards()"
          (addChartToDashboard)="onAddChartToDashboard($event)"
          (removeChartFromDashboard)="onRemoveChartFromDashboard($event)"
          (createDashboard)="onCreateDashboard($event)"
        />
      }
    </div>
  </div>
</div>
<ng-content />
